// Copyright (c) 2020 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import * as React from "react";
import type { JSX } from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";

import { IState } from "states/states";
import { IAction } from "actions";
import { Bus, IEnergyMeter, IInput, IModule, IOutput } from "shared/types/parameter";

interface IModuleExtProps {
  index: number;
  showModuleComment: boolean;
}

interface IModuleProps {
  parameter: IModule;
  value: boolean | undefined;
  inputs: IInput[];
  outputs: IOutput[];
  energymeters: IEnergyMeter[];
  showId: boolean;
}

const mapStateToProps = (state: IState, ownProps: IModuleExtProps) => {
  const curUser = state.site.userList?.find((curItem) => curItem.secId === state.site.user?.secId);
  const props: IModuleProps = {
    parameter: state.para.parameter!.module[ownProps.index],
    value: state.data.module[ownProps.index],
    inputs: state.para.parameter!.input,
    outputs: state.para.parameter!.output,
    energymeters: state.para.parameter!.energymeter,
    showId: Boolean(curUser?.accessRights.setVirtualParameters),
  };
  return props;
};

interface IModuleDispatch {}

const mapDispatchToProps = (dispatch: (action: IAction<any>) => void) => {
  const dispatchProps: IModuleDispatch = {};
  return dispatchProps;
};

class ModuleComponent extends React.Component<IModuleExtProps & IModuleProps & IModuleDispatch> {
  public render() {
    return (
      <tr className="moduleitem">
        {this.props.showId && <td className="optional-lg">{this.props.parameter.id}</td>}
        <td>{this.props.parameter.name}</td>
        <td className="optional-md">{this.props.parameter.type}</td>
        <td className="optional-lg">{this.props.parameter.address}</td>
        <td>{this.renderUsage()}</td>
        <td className="value-col">
          {this.props.parameter.isEnabled === false ?
            <FormattedMessage id="Disabled" />
          : this.props.value === true ?
            <FormattedMessage id="OK" />
          : this.props.value === false ?
            <FormattedMessage id="Failed" />
          : <FormattedMessage id="Unknown" />}
        </td>
        {this.props.showModuleComment && (
          <td className="optional-lg">
            <span>{this.props.parameter.comment}</span>
          </td>
        )}
      </tr>
    );
  }

  private renderUsage() {
    const usageItems: JSX.Element[] = [];
    const inputUsage = this.props.inputs
      .filter((curItem) => curItem.bus === Bus.MODULE && curItem.module === this.props.parameter.id)
      .map((curItem) => curItem.name);
    if (inputUsage.length > 0) {
      usageItems.push(
        <li key="input" title={inputUsage.join(", ")}>
          {inputUsage.length} <FormattedMessage id="Input(s)" />
        </li>,
      );
    }
    const outputUsage = this.props.outputs
      .filter((curItem) => curItem.bus === Bus.MODULE && curItem.module === this.props.parameter.id)
      .map((curItem) => curItem.name);
    if (outputUsage.length > 0) {
      usageItems.push(
        <li key="output" title={outputUsage.join(", ")}>
          {outputUsage.length} <FormattedMessage id="Output(s)" />
        </li>,
      );
    }
    const emUsage = this.props.energymeters
      .filter((curItem) => curItem.bus === Bus.MODULE && curItem.module === this.props.parameter.id)
      .map((curItem) => curItem.name);
    if (emUsage.length > 0) {
      usageItems.push(
        <li key="em" title={emUsage.join(", ")}>
          {emUsage.length} <FormattedMessage id="Energy Meter(s)" />
        </li>,
      );
    }
    return <ul>{usageItems}</ul>;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModuleComponent);
